import { render, staticRenderFns } from "./InvoiceSetting_Details.vue?vue&type=template&id=cb36d980&"
import script from "./InvoiceSetting_Details.vue?vue&type=script&lang=js&"
export * from "./InvoiceSetting_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports